<div class="sign-container">
  <sign-entry></sign-entry>
</div>
